import styled from "styled-components";
import colors from "../../theme/palette"; // Adjust import path if needed

export const WhiteBackgroundWrapper = styled.div`
  background: rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(10px);
  border-radius: 15px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  padding: 2rem;
  max-width: 1400px;
  margin: 2rem auto;
  position: relative;
  z-index: 1;

  @media (max-width: 768px) {
    padding: 1rem;
    margin: 0.5rem;
  }
`;

export const ContentWrapper = styled.div`
  background: #ffffff;
  border-radius: 15px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  padding: 2rem;
  margin: 2rem;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 1;

  @media (max-width: 768px) {
    padding: 1rem;
    margin: 1rem;
  }
`;

export const EventsSection = styled.section`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  text-align: center;
  position: relative;
  z-index: 1;
  padding: 2rem 0;

  h1 {
    font-size: 2.5rem;
    margin-bottom: 1.5rem;
    color: ${(props) => props.theme.primary};

    @media (max-width: 768px) {
      font-size: 2rem;
    }
  }

  p {
    max-width: 800px;
    margin: 0 auto 2rem;
    font-size: 1.2rem;
    color: ${(props) => props.theme.text};

    @media (max-width: 768px) {
      font-size: 1rem;
      margin-bottom: 1rem;
    }
  }
`;

export const CalendarContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 2rem;
  margin: 2rem auto;
  position: relative;
  z-index: 1;
  max-width: 1200px;
  width: 100%;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 1rem;
    margin: 1rem auto;
  }
`;

export const CalendarCard = styled.div`
  background: #fff;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.4);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  margin: 0 auto;
  width: fit-content;
  min-width: 300px;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
  }

  @media (max-width: 768px) {
    margin: 0 auto 1rem;
    min-width: 280px;
    
    &:hover {
      transform: none;
    }
  }

  .date-container {
    background: #f8f9fa;
    padding: 1rem;
    text-align: center;
    border-bottom: 1px solid #eee;

    h2 {
      font-size: 2rem;
      margin: 0;
      color: #333;
    }

    p {
      margin: 0;
      color: #666;
      font-size: 1.1rem;
    }
  }

  .event-details {
    padding: 1.5rem;
    text-align: center;

    h2 {
      margin: 0 0 1rem 0;
      color: #333;
      font-size: 1.5rem;
      text-align: center;
    }

    p {
      margin: 0.5rem 0;
      color: #666;
      text-align: center;
    }

    .description {
      margin-top: 1rem;
      color: #666;
      line-height: 1.6;
      text-align: center;
    }
  }

  .event-links {
    margin-top: 1rem;
    text-align: center;

    .links-container {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
      margin-top: 0.5rem;
      align-items: center;
    }

    .event-link {
      display: inline-flex;
      align-items: center;
      padding: 0.5rem 1rem;
      border-radius: 6px;
      text-decoration: none;
      font-size: 0.9rem;
      font-weight: 500;
      transition: all 0.3s ease;
      background: ${(props) => props.theme.primary}15;
      color: ${(props) => props.theme.primary};
      border: 1px solid ${(props) => props.theme.primary}30;

      &:hover {
        background: ${(props) => props.theme.primary}25;
        transform: translateY(-1px);
      }

      .link-icon {
        margin-right: 0.5rem;
        font-size: 1.1rem;
      }

      &.zoom {
        background: #2D8CFF15;
        color: #2D8CFF;
        border-color: #2D8CFF30;
      }

      &.meet {
        background: #00897B15;
        color: #00897B;
        border-color: #00897B30;
      }

      &.teams {
        background: #6264A715;
        color: #6264A7;
        border-color: #6264A730;
      }

      &.webinar {
        background: #FF6B6B15;
        color: #FF6B6B;
        border-color: #FF6B6B30;
      }

      &.registration {
        background: #4CAF5015;
        color: #4CAF50;
        border-color: #4CAF5030;
      }

      @media (max-width: 768px) {
        font-size: 0.85rem;
        padding: 0.4rem 0.8rem;
      }
    }
  }
`;

export const DownloadOverlay = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  opacity: 0;
  transition: opacity 0.3s ease;
  z-index: 2;
  pointer-events: auto;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 4px;
  padding: 4px;
`;

export const DownloadButton = styled.button`
  background: transparent;
  border: none;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  color: #333;
  padding: 0;
  
  &:hover {
    color: #007bff;
    transform: scale(1.1);
  }

  svg {
    width: 20px;
    height: 20px;
  }

  @media (max-width: 768px) {
    width: 28px;
    height: 28px;

    svg {
      width: 18px;
      height: 18px;
    }
  }
`;

export const ImageContainer = styled.div`
  position: relative;
  width: 100%;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);

  &:hover ${DownloadOverlay} {
    opacity: 1;
  }
`;

export const EventImage = styled.img`
  width: 100%;
  height: auto;
  object-fit: contain;
  border-radius: 0;
  transition: opacity 0.3s ease;
  background: rgba(0, 0, 0, 0.03);
  padding: 0.5rem;
  max-height: 400px;
  
  &.error {
    opacity: 0.7;
  }
`;

export const ImageErrorOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.2rem;
`;

export const LoadingSpinner = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
`;

export const NoEventsMessage = styled.div`
  text-align: center;
  padding: 2rem;
  color: #666;
  font-size: 1.2rem;
`;